const isMobile = () => (window.innerWidth || document.body.clientWidth) < 415;

export default isMobile;